module.exports = __webpack_public_path__ + "img/facebook-icon2.714552c5.svg";